import React from 'react';

/**
 * AdminLoadingState component for consistent loading states in admin interface
 */
const AdminLoadingState = ({ 
  message = 'Loading...', 
  size = 'medium',
  fullScreen = false 
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  };

  const containerClasses = fullScreen 
    ? 'min-h-screen bg-gray-900 flex items-center justify-center'
    : 'flex items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div className="text-center">
        <div className={`animate-spin rounded-full border-b-2 border-teal-500 mx-auto mb-4 ${sizeClasses[size]}`}></div>
        <p className="text-gray-300 dark:text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default AdminLoadingState;
